import { init } from '@elastic/apm-rum';

const apm = init({
  active: true,
  serverUrl: '/api/apm',
  serverUrlPrefix: '/whisky/',
  serviceName: 'portal-home',
  serviceVersion: window.env?.version ?? 'local',
  environment: window.env?.stage ?? 'dev',
  transactionSampleRate: 0.1,
});

const portalStartTimestamp = new Date();
apm.setCustomContext({ portalStartTimestamp });

import('./src/Application.container');

window.debugModuleFederation = () => {
  console.log(__webpack_share_scopes__);
};
